class SimpleAnnouncementCarousel extends HTMLElement {
  constructor() {
    super();

    this.currentIndex = 0;
    this.slides = [];
    this.isAnimating = false;
    this.autorotateInterval = null;

    this.config = {
      autorotate: this.dataset.autorotate === "true",
      autorotateSpeed: parseInt(this.dataset.autorotateSpeed) * 1000 || 5000,
      transitionDuration: 1000, // 1s transition
    };

    this.init();
  }

  init() {
    const slider = this.querySelector(".announcement-slider");
    if (!slider) return;

    this.slides = Array.from(
      slider.querySelectorAll(".announcement-slider__slide")
    );
    if (this.slides.length <= 1) return;

    // Clone slides for infinite loop
    this.cloneSlides();

    // Start at first real slide (index 1, after cloned last slide)
    this.currentIndex = 1;

    // Setup buttons
    this.setupButtons();

    // Setup auto-play
    if (this.config.autorotate) {
      this.startAutorotate();
    }

    // Setup touch/swipe support
    this.setupTouch();

    // Initial position
    this.updatePosition();
  }

  cloneSlides() {
    const slider = this.querySelector(".announcement-slider");
    const firstSlide = this.slides[0].cloneNode(true);
    const lastSlide = this.slides[this.slides.length - 1].cloneNode(true);

    firstSlide.classList.add("cloned");
    lastSlide.classList.add("cloned");

    slider.appendChild(firstSlide);
    slider.insertBefore(lastSlide, slider.firstChild);

    // Update slides array
    this.slides = Array.from(
      slider.querySelectorAll(".announcement-slider__slide")
    );
  }

  setupButtons() {
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (this.prevButton) {
      this.prevButton.addEventListener("click", () => this.prev());
    }

    if (this.nextButton) {
      this.nextButton.addEventListener("click", () => this.next());
    }
  }

  setupTouch() {
    let startX = 0;
    let startY = 0;
    let isDragging = false;

    this.addEventListener("touchstart", (e) => {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      isDragging = true;
    });

    this.addEventListener("touchmove", (e) => {
      if (!isDragging) return;
      e.preventDefault();
    });

    this.addEventListener("touchend", (e) => {
      if (!isDragging) return;
      isDragging = false;

      const endX = e.changedTouches[0].clientX;
      const endY = e.changedTouches[0].clientY;
      const diffX = startX - endX;
      const diffY = startY - endY;

      // Only trigger if horizontal swipe is greater than vertical
      if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 50) {
        if (diffX > 0) {
          this.next();
        } else {
          this.prev();
        }
      }
    });
  }

  updatePosition() {
    const slider = this.querySelector(".announcement-slider");
    if (!slider) return;

    const container =
      this.closest(".announcement-bar-w-menu-list__slider") || this;
    const slideWidth = container.offsetWidth;
    const translateX = -this.currentIndex * slideWidth;

    slider.style.transition = `transform ${this.config.transitionDuration}ms ease`;
    slider.style.transform = `translate3d(${translateX}px, 0, 0)`;

    // Handle infinite loop
    setTimeout(() => {
      if (this.currentIndex === 0) {
        // Jump to last real slide (without transition)
        slider.style.transition = "none";
        this.currentIndex = this.slides.length - 2;
        const realTranslateX = -this.currentIndex * slideWidth;
        slider.style.transform = `translate3d(${realTranslateX}px, 0, 0)`;
      } else if (this.currentIndex === this.slides.length - 1) {
        // Jump to first real slide (without transition)
        slider.style.transition = "none";
        this.currentIndex = 1;
        const realTranslateX = -this.currentIndex * slideWidth;
        slider.style.transform = `translate3d(${realTranslateX}px, 0, 0)`;
      }
    }, this.config.transitionDuration + 50);
  }

  next() {
    if (this.isAnimating) return;
    this.isAnimating = true;

    this.currentIndex++;
    this.updatePosition();

    setTimeout(() => {
      this.isAnimating = false;
    }, this.config.transitionDuration);
  }

  prev() {
    if (this.isAnimating) return;
    this.isAnimating = true;

    this.currentIndex--;
    this.updatePosition();

    setTimeout(() => {
      this.isAnimating = false;
    }, this.config.transitionDuration);
  }

  startAutorotate() {
    this.autorotateInterval = setInterval(() => {
      this.next();
    }, this.config.autorotateSpeed);

    // Pause on hover
    this.addEventListener("mouseenter", () => {
      if (this.autorotateInterval) {
        clearInterval(this.autorotateInterval);
      }
    });

    this.addEventListener("mouseleave", () => {
      this.startAutorotate();
    });
  }

  disconnectedCallback() {
    if (this.autorotateInterval) {
      clearInterval(this.autorotateInterval);
    }
  }
}

customElements.define(
  "simple-announcement-carousel",
  SimpleAnnouncementCarousel
);
